/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ButtonComponent } from '@ods/system';
import { SnackbarCloseButtonComponent } from '../snackbar-close-button/snackbar-close-button.component';
import { SnackBarData } from '../snackbar.model';

@Component({
  selector: 'ozgcloud-snackbar-info',
  templateUrl: './snackbar-info.component.html',
  host: { class: 'flex items-center justify-between gap-1' },
  imports: [ButtonComponent, SnackbarCloseButtonComponent],
})
export class SnackbarInfoComponent {
  public snackBarRef = inject(MatSnackBarRef<SnackbarInfoComponent>);
  public data = inject<SnackBarData>(MAT_SNACK_BAR_DATA);

  get message(): string {
    return this.data.message;
  }

  revoke(): void {
    this.snackBarRef.dismissWithAction();
  }

  close(): void {
    this.snackBarRef.dismiss();
  }
}
